import { render, staticRenderFns } from "./logo-wall.vue?vue&type=template&id=96ba3a38&lang=pug&"
import script from "./logo-wall.vue?vue&type=script&lang=js&"
export * from "./logo-wall.vue?vue&type=script&lang=js&"
import style0 from "./logo-wall.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports